/**
 * @generated SignedSource<<9f53bc5c8eeb104c8b3ae709772115a7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateAutojoinDomainInput = {
  id: string;
  name?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updateAutojoinDomainMutation$variables = {
  input: UpdateAutojoinDomainInput;
};
export type updateAutojoinDomainMutation$data = {
  readonly updateAutojoinDomain: {
    readonly AutojoinDomain: {
      readonly id: string;
      readonly name: string | null;
    } | null;
  } | null;
};
export type updateAutojoinDomainMutation = {
  variables: updateAutojoinDomainMutation$variables;
  response: updateAutojoinDomainMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateAutojoinDomainPayload",
    "kind": "LinkedField",
    "name": "updateAutojoinDomain",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AutojoinDomain",
        "kind": "LinkedField",
        "name": "AutojoinDomain",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateAutojoinDomainMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateAutojoinDomainMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "20097a6ced7b1cdc569416c09fd0af6b",
    "id": null,
    "metadata": {},
    "name": "updateAutojoinDomainMutation",
    "operationKind": "mutation",
    "text": "mutation updateAutojoinDomainMutation(\n  $input: UpdateAutojoinDomainInput!\n) {\n  updateAutojoinDomain(input: $input) {\n    AutojoinDomain {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e6b2c7c7a247b1a20ec02bfcae5d42af";

export default node;
